import React, { useState } from 'react';
// import PropTypes from 'prop-types';
import {
  Row,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Button,
  Col,
  Spinner,
} from 'reactstrap';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import './portfolio.css';
import { Separator } from '../common/Seperator';
import { useCurrentUser, useWebApp } from '../../hooks/telegram';
import { toast } from 'react-toastify';
import { FaCopy, FaEthereum, FaTelegramPlane, FaUsers } from 'react-icons/fa';
import { formatEther, formatUnits } from 'viem';
import { formatAddress } from '../../lib/utils';

const PresaleTabs = ({
  purchaseHistory,
  referrals,
  downlinePurchases,
  loading,
}) => {
  const webapp = useWebApp();
  const currentUser = useCurrentUser();
  const [activeTab, setActiveTab] = useState('1');
  const [showAllDownlines, setShowAllDownlines] = useState(false);
  const ITEMS_PER_PAGE = 10;

  const totalRefEarningn = () => {
    let total = 0;
    for (let i = 0; i < referrals.length; i++) {
      total += parseFloat(formatEther(referrals[i].referralAmount));
    }
    return total;
  };

  function fallbackCopyTextToClipboard(text) {
    var textArea = document.createElement('textarea');
    textArea.value = text;

    // Avoid scrolling to bottom
    textArea.style.top = '0';
    textArea.style.left = '0';
    textArea.style.position = 'fixed';

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      var successful = document.execCommand('copy');
      var msg = successful ? 'successful' : 'unsuccessful';
      console.log('Fallback: Copying text command was ' + msg);
    } catch (err) {
      console.error('Fallback: Oops, unable to copy', err);
    }

    document.body.removeChild(textArea);
  }

  async function copyTextToClipboard(text) {
    if (!navigator.clipboard) {
      fallbackCopyTextToClipboard(text);
      return;
    }
    await navigator.clipboard.writeText(text);
  }

  const copyReferralLink = async () => {
    try {
      const referralLink = `https://t.me/ploutos_labs_bot/app?startapp=${currentUser?.telegramId}`;
      await copyTextToClipboard(referralLink);
      toast.success('Referral link copied!', {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
      });
    } catch (error) {
      toast.error('Failed to copy link', {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
      });
    }
  };

  const handleShare = () => {
    const referralLink = `https://t.me/ploutos_labs_bot/app?startapp=${currentUser?.telegramId}`;
    const inviteMessage = `🚀 Join the Ploutos Labs Presale and secure your place in the future of decentralized finance! 💰 \n\nTap here to get started: ${referralLink}`;

    const telegramUrl = `https://t.me/share/url?url=${encodeURIComponent(
      referralLink
    )}&text=${encodeURIComponent(inviteMessage)}`;

    webapp.openTelegramLink(telegramUrl);
  };

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const refEarning = (purchase) => {
    const tokenAmount = parseFloat(formatUnits(purchase.tokenAmount, 9));
    if (purchase.directReferrer === currentUser?.address) {
      return tokenAmount * 0.1;
    } else {
      return tokenAmount * 0.05;
    }
  };

  const displayedDownlines = showAllDownlines
    ? downlinePurchases
    : downlinePurchases.slice(0, ITEMS_PER_PAGE);

  return (
    <div className="portfolio">
      <Nav tabs>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === '1' })}
            onClick={() => {
              toggle('1');
            }}
          >
            Refferals
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === '2' })}
            onClick={() => {
              toggle('2');
            }}
          >
            History
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === '3' })}
            onClick={() => {
              toggle('3');
            }}
          >
            Downline Purchases
          </NavLink>
        </NavItem>
      </Nav>
      <TabContent activeTab={activeTab}>
        <TabPane tabId="1">
          <Row className="justify-content-center align-items-center text-center">
            <div className="mt-4">
              <h4>Referrals</h4>
              <p>
                Share your referral link and earn 10% of every purchase your
                referral makes plus 5% of their downlines purchase. Use the
                buttons below to share or copy your referral link.
              </p>
              <Separator />
              <Row className="referrals-grid">
                <Col className="referral-link-container">
                  <div className="referral-link-text mt-3">Referral Link</div>
                  <div>
                    {currentUser
                      ? `https://t.me/ploutos_labs_bot/app?startapp=${currentUser.telegramId}`
                      : ''}
                  </div>
                  <div className="d-flex justify-content-between my-3">
                    <Button
                      className="share-btn"
                      onClick={handleShare}
                      aria-label="Share referal link"
                    >
                      <FaTelegramPlane /> Share Link
                    </Button>
                    <Button
                      onClick={copyReferralLink}
                      className="share-btn copy-button "
                      aria-label="Copy referral link"
                    >
                      <FaCopy /> Copy Link
                    </Button>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <span>
                    Total Earnings:{' '}
                    <span style={{ fontWeight: 'bold' }}>
                      <FaEthereum />
                      {totalRefEarningn()}
                    </span>
                  </span>
                  {referrals.map((r) => (
                    <React.Fragment key={r.date}>
                      <div className="referral-card d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center">
                          <div className="avatar-circle">
                            <span>{formatAddress(r.buyer)}</span>
                          </div>
                          {/* <span className="referral-username ml-2">
                            {r.username}
                          </span> */}
                        </div>
                        <span className="referral-balance">
                          +{formatEther(r.referralAmount)}
                        </span>
                      </div>
                    </React.Fragment>
                  ))}
                </Col>
              </Row>
            </div>
          </Row>
        </TabPane>
        <TabPane tabId="2">
          <Row className="justify-content-center align-items-center text-center">
            <div className="mt-4">
              <h4>Presale History</h4>
              {purchaseHistory.length === 0 ? (
                <p>No record found</p>
              ) : (
                <div className="purchase-history-list">
                  {loading ? (
                    <Spinner />
                  ) : (
                    purchaseHistory.map((purchase) => (
                      <div key={purchase.id} className="purchase-history-item">
                        <div className="history-date">
                          Date:{' '}
                          {new Date(
                            parseInt(purchase.date || 2) * 1000
                          ).toLocaleDateString()}
                        </div>
                        <div className="history-eth">
                          ETH: {formatEther(purchase.ethSpent)}
                        </div>
                        <div className="history-plt">
                          PLTL: {formatUnits(purchase.tokenAmount, 9)}
                        </div>
                      </div>
                    ))
                  )}
                </div>
              )}
            </div>
          </Row>
        </TabPane>
        <TabPane tabId="3">
          <Row className="justify-content-center align-items-center text-center">
            <div className="mt-4">
              <h4>Downline Purchases</h4>
              <p>
                Share your referral link and earn 10% of every purchase your
                referral makes plus 5% of their downlines purchases. Share your
                referral link to your downlines to earn more.
              </p>
              <Separator />
              {downlinePurchases.length === 0 ? (
                <p>No downline purchases</p>
              ) : (
                <div className="downline-purchases-list">
                  {loading ? (
                    <Spinner />
                  ) : (
                    <div className="downline-stats">
                      <div className="downline-stat-item">
                        <div className="stat-icon">
                          <FaUsers />
                        </div>
                        <div className="stat-info">
                          <div className="stat-label">Total downlines</div>
                          <div className="stat-value">
                            {downlinePurchases.length}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {displayedDownlines.map((purchase, index) => (
                    <div key={index} className="downline-purchase-item">
                      <div className="purchase-header flex-column flex-md-row">
                        <div className="downline-address w-100">
                          <span className="address-label d-block d-md-inline">
                            Downline Address:
                          </span>
                          <span className="address-value ms-0 ms-md-2 d-block d-md-inline">
                            {formatAddress(purchase.buyer)}
                          </span>
                        </div>
                        <div className="purchase-date mt-2 mt-md-0">
                          {new Date(
                            parseInt(purchase.date) * 1000
                          ).toLocaleDateString()}
                        </div>
                      </div>
                      <div className="purchase-details">
                        <div className="purchase-info-grid">
                          <div className="purchase-amount">
                            <span className="amount-label d-block">ETH:</span>
                            <span className="amount-value">
                              {formatEther(purchase.amount)}
                              {purchase.amountUSD && (
                                <small className="d-block mt-1">
                                  (${purchase.amountUSD.toFixed(2)} USD)
                                </small>
                              )}
                            </span>
                          </div>
                          <div className="purchase-tokens">
                            <span className="tokens-label d-block">PLTL:</span>
                            <span className="tokens-value">
                              {formatUnits(purchase.tokenAmount, 9)}
                            </span>
                          </div>
                          <div className="purchase-level">
                            <span className="level-label d-block">Level:</span>
                            <span className="level-value">
                              {purchase.directReferrer === currentUser?.address
                                ? 'First Generation'
                                : 'Second Generation'}
                            </span>
                          </div>
                          <div className="purchase-tokens">
                            <span className="tokens-label d-block">
                              PLTL Earned:
                            </span>
                            <span className="tokens-value">
                              {refEarning(purchase)}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}

                  {downlinePurchases.length > ITEMS_PER_PAGE &&
                    !showAllDownlines && (
                      <div className="show-more-container">
                        <Button
                          className="show-more-btn"
                          onClick={() => setShowAllDownlines(true)}
                        >
                          Show More ({downlinePurchases.length - ITEMS_PER_PAGE}
                          )
                        </Button>
                      </div>
                    )}
                </div>
              )}
            </div>
          </Row>
        </TabPane>
      </TabContent>
    </div>
  );
};

PresaleTabs.propTypes = {
  purchaseHistory: PropTypes.array,
  referrals: PropTypes.array,
  downlinePurchases: PropTypes.array,
  loading: PropTypes.bool,
};

export default PresaleTabs;
